import React from 'react';
import PropTypes from 'prop-types';

function BrandLuxuria({ fill, className })
{
    return (
        <svg className={`tw-max-w-full tw-max-h-full tw-mx-auto ${className}`} viewBox="0 0 437 274" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path className={fill} d="M0.198845 0H44.8186V140.901C44.8186 140.901 43.6416 177.297 81.2197 178.474C118.787 179.646 117.616 140.901 117.616 140.901V0H162.235V139.724C162.235 139.724 171.694 223.094 81.2197 223.094C-8.0199 223.094 0.198845 137.375 0.198845 137.375V0Z" />
            <path className={fill} d="M182.34 0H225.788V158.51C225.788 158.51 236.35 271.234 109.543 273.583V231.313C109.543 231.313 178.819 231.313 182.34 162.031V0Z" />
            <path className={fill} d="M300.329 218.854C305.574 217.958 310.261 215.542 314.808 212.844L436.959 0.015625H393.407L286.741 185.859C279.287 198.849 285.037 214.349 297.079 220.427C297.845 219.667 298.912 219.094 300.329 218.854Z" />
            <path className={fill} d="M291.782 223.063H257.527C252.392 223.063 248.23 218.901 248.23 213.766V0.015625H291.782V223.063Z" />
            <path className={fill} d="M315.293 210.786C306.199 226.729 283.808 227.479 273.491 212.891C272.965 212.115 272.454 211.323 271.97 210.5L337.386 172.052L315.293 210.786Z" />
        </svg>
    );
}

BrandLuxuria.defaultProps = {
    fill: 'tw-fill-primary-brand-dark dark:tw-fill-primary-brand',
    className: '',
};

BrandLuxuria.propTypes = {
    fill: PropTypes.string,
    className: PropTypes.string,
};

export default BrandLuxuria;
